export default "__VITE_ASSET__B1vcbR01__"